import type { Lang } from "@/lib/level-utils";

export const APP_LANG_STORAGE_KEY = "elzaguan-lang";

/** Detect language from browser — "en" if navigator.language starts with "en", otherwise "es" */
export function detectBrowserLang(): Lang {
  if (typeof navigator !== "undefined" && navigator.language?.startsWith("en")) {
    return "en";
  }
  return "es";
}

export function getStoredAppLang(): Lang | null {
  if (typeof window === "undefined") return null;

  const htmlLang = document.documentElement.lang;
  if (htmlLang === "es" || htmlLang === "en") return htmlLang;

  const storedLang = window.localStorage.getItem(APP_LANG_STORAGE_KEY);
  return storedLang === "es" || storedLang === "en" ? storedLang : null;
}

export function resolveAppLang(): Lang {
  return getStoredAppLang() ?? detectBrowserLang();
}
